import { ctx, translate, QuoteItem, Address, punchout } from "..";
import { useEffect, useState } from "preact/hooks";
import { html } from "htm/preact";
import { route } from 'preact-router';

import CartItemView from "./CartItemView"

export default function CartView() {

    const { state, dispatch } = ctx();

    const [name, setName] = useState('');
    const [department, setDepartment] = useState('');
    const [email, setEmail] = useState('');

    const [className, setClassName] = useState('');

    const isEmptyEmail = !email && className;
    const isEmptyName = !name && className;
    const isEmptyDepartment = !department && className;

    const isCartEmpty = state.cart.items.length == 0;

    const onPunchoutClick = () => {
        if (!localStorage.getItem('punchout_id')) {
            return alert('You are not in a punchout session. Please start a session from your procurement system.');
        }
        punchout.submitCart({
            items: state.cart.items.map(it => ({ ...it, product: { ...it.product, price: Math.round(it.product.price * 100) } })),
            currency: translate('USD'),
        })
            .then(() => { });
    };

    const saveQuote = (quote: NewQuote) => {
        fetch('https://punchout.cloud/api/v1/quotes', {
            body: JSON.stringify(quote),
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('punchout_id') || '',
            },
        })
            .then(res => res.json())
            .then((quote) => {
                dispatch({ type: 'quote.created', quote });
                route('/quotes');
            })
            .catch(console.log);
    }

    const onCreateQuoteClick = () => {
        if (!localStorage.getItem('punchout_id')) {
            return alert('You are not in a punchout session. Please start a session from your procurement system.');
        }

        if (isCartEmpty) {
            return alert('Cart is empty');
        }

        if (
            !email ||
            !name ||
            !department
        ) return setClassName('highlight')

        const newQuote: NewQuote = {
            items: state.cart.items.map(it => {
                const price = Math.round(it.product.price * 1000);
                const item = { ...it, name: it.product.name, sku: it.product.sku, unit: 'EA', data: { ...it.product }, price };
                for (const key in item.data) {
                    if (typeof (item.data[key]) !== 'string') {
                        delete (item.data as any)[key];
                    }
                }
                return item;
            }),
            currency: translate('USD'),
            contact_name: name,
            email: email,
            data: {
                department,
            },
        };
        
        saveQuote(newQuote);
    };

    return html`<div class="app-content content ecommerce-application">
        <div class="content-wrapper container-xxl p-0">
        <div class="content-body">
    <div class="bs-stepper checkout-tab-steps">
        <div class="bs-stepper-content">
            <!-- Checkout Place order starts -->
            <div id="step-cart" class="content active dstepper-block" role="tabpanel" aria-labelledby="step-cart-trigger">
                <div id="place-order" class="list-view product-checkout">
                    <!-- Checkout Place Order Left starts -->
                    <div class="checkout-items">
                        ${state.cart.items.map(CartItemView)}

                    </div>
                    <!-- Checkout Place Order Left ends -->

                    <!-- Checkout Place Order Right starts -->
                    <div class="checkout-options">
                        <div class="card">
                            <div class="card-body">
                                <div class="price-details">
                                    <ul class="list-unstyled">
                                        <li class="price-detail">
                                            <div class="detail-title detail-total">${translate('Total')}</div>
                                            <div class="detail-amt fw-bolder">${state.cart.items.reduce((p, n) => p + n.product.price * n.quantity, 0).toFixed(2).replace(".", ",")} ${translate('USD')}</div>
                                        </li>
                                    </ul>
                                    <div class="form-group" style="gap:10px;display:flex;flex-direction:column;margin-bottom:15px">
                                    ${state.role == 'buyer' ? html`
                                    <button onclick=${(ev) => {
                                        ev.preventDefault();
                                        onPunchoutClick();
                                    }} type="button" class="btn btn-primary w-100 btn-next place-order waves-effect waves-float waves-light">Punchout</button> 
                                      <a href="/" style="margin-top:10px;" type="button" class="btn btn-light w-100 btn-next waves-effect waves-float waves-light">${translate('Continue Shopping')}</a>
                                     ` : ''
                                    }

                                    ${state.role != 'buyer' ? html`
                                        <input onkeyup=${ev => setEmail(ev.target.value)} type="email" class="cart-field form-control ${isEmptyEmail}" placeholder="${translate('Handlekurv')} (${translate('Navn på handlekurv')})" aria-label="Email" aria-describedby="input-email" required />
                                        <input onkeyup=${ev => setName(ev.target.value)} type="text" class="cart-field form-control ${isEmptyName}" placeholder="${translate('Bestiller')} (${translate('Navn på bestiller')})" aria-label="Name" aria-describedby="input-name" required />
                                        <input onkeyup=${ev => setDepartment(ev.target.value)} type="text" class="cart-field form-control ${isEmptyDepartment}" placeholder="${translate('avdeling')} (${translate('Navn på avdeling')})" aria-label="Department" aria-describedby="input-department" required />` : ''
                                    }


                                    
                                    </div>
                                    <div style="gap:10px;display:flex;flex-direction:column;margin-bottom:15px">
                                    ${state.role != 'buyer'  ? html`
                                    <button onclick=${(ev) => {
                                        ev.preventDefault();
                                        onCreateQuoteClick();
                                    }} type="button" class="btn btn-primary w-100 btn-next place-order waves-effect waves-float waves-light">${translate('Create Quote')}</button>${state.role != 'requester' && html``}
                                     ` : ''
                                    }
                                     ${state.role == 'requester' ? html`
                                        <a href="/" style="margin-top:10px;" type="button" class="btn btn-light w-100 btn-next waves-effect waves-float waves-light">${translate('Continue Shopping')}</a>` : ''
                                    }
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- Checkout Place Order Right ends -->

                        
                        ${state.role == 'approver' ? html`
                            <span>OR</span>
                            <div class="card second">
                            <button onclick=${(ev) => {
                            ev.preventDefault();
                            onPunchoutClick();
                        }} type="button" class="btn btn-primary w-100 btn-next place-order waves-effect waves-float waves-light">Punchout</button>
                        <a href="/" style="margin-top:10px;" type="button" class="btn btn-light w-100 btn-next waves-effect waves-float waves-light">${translate('Continue Shopping')}</a>
                        </div>
                         ` : ''
                        }
                    </div>
                </div>
                <!-- Checkout Place order Ends -->
            </div>

        </div>
    </div>
        </div>
    </div>
</div>

`;
}

interface NewQuote {
    tags?: string[];
    email?: string;
    contact_name?: string;
    currency: string;
    items: QuoteItem[];
    shipping_cost?: number;
    tax?: number;
    data?: { [key: string]: string };
    shipping?: Address;
}